export function formatNUMBER(value) {
  if (value && typeof value !== 'object') {
    return value.replace(/\D/g, '');
  }
  return '';
}
